module.exports = __webpack_public_path__ + "static/media/21.d84f7186.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/21.JPG
// module id = 464
// module chunks = 0